import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Lightbulb, Plus, Loader2, Check } from "lucide-react";
import api, { formatMoney2, formatNumber } from "../../lib/api";
import { avisarRevision } from "./AvisoCaros";

export function SugerenciasLibre({ importId, version, onAdded }) {
  const [d, setD] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    if (!importId) return;
    api.get("/libre-excluidos/sugerencias", { params: { import_id: importId } }).then((r) => setD(r.data)).catch(() => setD(null));
  }, [importId, version]);
  if (!d || !d.sugerencias.length) return null;

  const quitar = async (lista) => {
    setBusy(true);
    try {
      for (const s of lista) await api.post("/libre-excluidos", { tipo: "cn", valor: s.cn, descripcion: s.descripcion }).catch(() => {});
      toast.success(lista.length > 1 ? `${lista.length} artículos quitados de la venta libre` : "Quitado de la venta libre de los incentivos");
      onAdded?.();
      avisarRevision();
    } finally { setBusy(false); }
  };
  const revisar = async (lista) => {
    setBusy(true);
    try {
      await api.post("/libre-excluidos/revisados", { cns: lista.map((s) => s.cn) });
      toast.success("Marcados como revisados: siguen contando como venta");
      setD({ ...d, nuevos: 0, sugerencias: d.sugerencias.map((s) => (lista.some((x) => x.cn === s.cn) ? { ...s, nuevo: false } : s)) });
      avisarRevision();
    } catch { toast.error("No se pudo guardar"); }
    finally { setBusy(false); }
  };
  const nuevos = d.sugerencias.filter((s) => s.nuevo);

  return (
    <div className="mt-4 rounded-lg border border-amber-200 bg-amber-50/60 p-3" data-testid="libre-sugerencias">
      <div className="flex items-start justify-between gap-2 mb-2">
        <div>
          <div className="text-xs font-bold text-amber-800 flex items-center gap-1"><Lightbulb size={13} /> Sugerencias de este mes</div>
          <div className="text-[11px] text-amber-900/70">Medicamentos de más de 50 € la unidad cobrados enteros (sin receta del SNS): {formatMoney2(d.total)} en total.</div>
        </div>
        <div className="flex flex-col gap-1 shrink-0">
          <button onClick={() => quitar(d.sugerencias)} disabled={busy} className="btn btn-sm btn-primary" data-testid="libre-sug-todas">
            {busy ? <Loader2 size={12} className="animate-spin" /> : <Plus size={12} />} Quitar todas
          </button>
          {nuevos.length > 0 && (
            <button onClick={() => revisar(nuevos)} disabled={busy} className="btn btn-sm btn-outline" data-testid="libre-sug-revisadas">
              <Check size={12} /> Revisadas, contar
            </button>
          )}
        </div>
      </div>
      <ul className="space-y-1">
        {d.sugerencias.map((s, i) => (
          <li key={s.cn} className="flex items-center gap-2 text-xs bg-white rounded-md px-2 py-1.5" data-testid={`libre-sug-${i}`}>
            <div className="flex-1 min-w-0">
              <div className="leading-snug">{s.nuevo && <span className="text-[9px] font-extrabold bg-red-500 text-white rounded px-1 mr-1 align-middle" data-testid={`libre-sug-nuevo-${i}`}>NUEVO</span>}<span className="font-mono text-slate-400 mr-1">{s.cn}</span>{s.descripcion}</div>
              <div className="text-slate-500">{formatNumber(s.uds)} uds · {formatMoney2(s.precio_medio)}/ud · <b className="text-slate-800">{formatMoney2(s.facturacion)}</b></div>
            </div>
            <button onClick={() => quitar([s])} disabled={busy} className="text-amber-700 hover:text-red-600 font-bold" title="Quitar de la venta libre" data-testid={`libre-sug-quitar-${i}`}><Plus size={14} /></button>
          </li>
        ))}
      </ul>
    </div>
  );
}
